import { ReactNode } from 'react';

export interface CategoryItem {
  categoryId: string;
  categoryName: string;
  categoryKey: string;
}
export interface CategoryTree extends CategoryItem {
  key: string;
  title: string;
  parentCategoryId: string;
  parentCategoryName: string;
  children: Array<CategoryTree>;
}
export type PlatformCode = 'FS' | 'BA';

export enum PermissionType {
  'ACTION',
  'FORM',
}

export enum NodeType {
  BUSINESS_DISTRICT,
  CITY,
  AREA,
}

export interface AreaListParams {
  largeAreaId?: string;
  areaId?: string;
  cityCode?: string;
  /** 0 表示业务区域数据  1 表示物流区域数据 */
  type?: AreaListParamsType;
}

/** 0 表示业务区域数据  1 表示物流区域数据 */
export enum AreaListParamsType {
  /** 表示业务区域数据 */
  BUSINESS = 0,
  /** 表示物流区域数据 */
  LOGISTICS = 1,
}

export interface AreaListItem {
  id: string;
  name: string;
}

export interface SearchAreaListItem {
  id: string;
  name: string;
  parentId: string;
  nodeType: NodeType;
  path: string;
}

export enum AreaType {
  LargeArea,
  Area,
  City,
  Cbd,
}

export interface IdEntity {
  areaType: AreaType;
  areaId: string | number;
  pAreaId: string | number;
  cityName: string;
}

export interface TreeDataItem {
  id: string;
  value: string;
  pId?: string;
  title: string | ReactNode;
  isLeaf: boolean;
  children?: TreeDataItem[];
}

export interface GenTreeNode {
  (data: AreaListItem[], pId?: string): TreeDataItem[];
}
export interface GenSearchTreeNode {
  (data: SearchAreaListItem[]): TreeDataItem[];
}

export interface AreaAboutInfoDtoItem {
  parentId: string;
  id: string;
  name: string;
}
export interface AreaAboutInfoDto {
  largeAreas?: AreaAboutInfoDtoItem[];
  areas?: AreaAboutInfoDtoItem[];
  cities?: AreaAboutInfoDtoItem[];
  cbds?: AreaAboutInfoDtoItem[];
}
